__turbopack_context__.v({
  "cards": "QGax2q_cards",
  "content": "QGax2q_content",
  "headContact": "QGax2q_headContact",
  "p": "QGax2q_p",
  "page-body-wrap": "QGax2q_page-body-wrap",
  "pagehero": "QGax2q_pagehero",
  "pageheropost": "QGax2q_pageheropost",
  "pageheropre": "QGax2q_pageheropre",
  "paragraph": "QGax2q_paragraph",
  "paragraph-content": "QGax2q_paragraph-content",
  "paragraph1": "QGax2q_paragraph1",
  "phonecontent": "QGax2q_phonecontent",
  "sectionCard": "QGax2q_sectionCard",
  "store": "QGax2q_store",
  "t": "QGax2q_t",
  "title": "QGax2q_title",
  "title1": "QGax2q_title1",
  "wrap-container": "QGax2q_wrap-container",
  "wrap-content": "QGax2q_wrap-content",
});
